import { PortalLayoutType, PortalType } from '@/modules/portalSettings/types'
import { PortalSettings } from '@/types/index'

const getPortalLayoutType = (portalType: PortalType): PortalLayoutType => {
  switch (portalType) {
    case PortalType.QuotesPortal:
      return PortalLayoutType.QUOTES_PORTAL_LAYOUT
    case PortalType.EssentialPortal:
    case PortalType.FullPortal:
    case PortalType.SupplierPortal:
      return PortalLayoutType.DEFAULT_LAYOUT
    default:
      return PortalLayoutType.PORTAL_UNAVAILABLE_LAYOUT
  }
}

const getVatRateText = (vatRate: number, portalSettings: PortalSettings): string => {
  return portalSettings.showVatRate ? ` ${vatRate}%` : ''
}

export { getPortalLayoutType, getVatRateText }
